module.exports = __webpack_public_path__ + "static/media/mail-05.c027739b.svg";